"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHostModule = void 0;
exports.buildHostModule = buildHostModule;
const isHostModule = (val) => val.__type === 'host';
exports.isHostModule = isHostModule;
function buildHostModule(val, host) {
    return val.create(host);
}
